import React from 'react';
import { TreeGraph } from 'types/backend/response/TreeGraph';

export interface ITreeConfigContext {
    selectTree: (treeId: string) => void;
    reloadTree: () => void;
    optionalTreeGraphs?: TreeGraph[];
    ontologyNodeContents: string[];
    addOntologyNodeContent: (content: string) => void;
    removeOntologyNodeContent: (content: string) => void;
}

const defaultContext: ITreeConfigContext = {
    optionalTreeGraphs: undefined,
    ontologyNodeContents: [],
    addOntologyNodeContent: () => {
        // Initial value. Replaced by context provider.
    },
    removeOntologyNodeContent: () => {
        // Initial value. Replaced by context provider.
    },
    selectTree: () => {
        // Initial value. Replaced by context provider.
    },
    reloadTree: () => {
        // Initial value. Replaced by context provider.
    },
};

const TreeConfigContext = React.createContext(defaultContext);

export default TreeConfigContext;
